import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../constants';
import { MQ_TABLET } from '../../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";

export default MediaQueryStyleSheet.create({
  root: {
    flex: 1,
  },
  header: {
    flex: 1,
  },
  headerNotes: {
    paddingVertical: 5,
    paddingHorizontal: 10,
  },
  row: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 10,
    paddingHorizontal: 5,
  },

  seperationBdr: {
    borderWidth: 0.5,
    borderColor: PALETTE.primaryStrokeLine,
    height: 1
  },

  seperationBdrView:{
    paddingVertical:20,
  },

  textAligning:{
    textAlign: 'center',
  },

  support: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  allAssets: {
    borderWidth: 0.5,
    borderColor: PALETTE.primaryStrokeLine,
    height: 1,
    backgroundColor: '#000000'
  },

  trigger: {
    alignItems: 'center',
    flexDirection: 'row',
    marginTop: 5,
  },

  backLink: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    transform: [{ rotate: '90deg' }],
    position: 'absolute',
    top: -20,
    left: 10,
  },

  headerBox: {
    borderWidth: 0.5,
    borderColor: PALETTE.primaryStrokeLine,
    marginTop:15,
    alignItems: 'center',
    justifyContent: 'center',
    width:200,
    alignSelf:'center',
    textAlign: 'center',
    paddingVertical: 5
  },

  logo: {
    height: 30,
    width: 30,
    paddingLeft: 30
  },
  dateSelectionBar:{
    flex: 1,
    justifyContent: 'center'
  },
  selectDateText: {
    marginRight: 10
  },
  assetText: {
    alignItems: 'center',
    flexDirection: 'row',
    padding: 10,
  },
  selected: {
    width: 20,
  },
  optionTitle: {
    flex: 1,
  },
  titleAlignCenter: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    textAlignVertical: 'center',
    alignItems:'center'
  },
  mrgnTp: {
    marginTop: 20,
  },
  mrgnLeft: {
    marginLeft: 25,
    //paddingBottom: 10,
  },
  currentAccHeader: {
    width: 280
  },
  tabletBlockCompnentList:{
    flex: 1,
  },
  assetTabletView:{
    flex: 1,
    flexDirection:'row'
  },
  assetBlockView:{
    flex: 0.4,
    marginRight:30
  },
  assetBlockComponent:{
    flex:1,
  },
  assetListView:{
    flex: 0.6,
  },
  dateSelectionBar:{
    flex:1,
  },
  displayPdf: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    alignSelf: 'center'
  },
  pdfContainer: {
    flex: 1,
  },
  centerMiddle: {
    position: 'absolute',
    zIndex: 4,
  },
  contentBorder: {
    marginTop:15,
    borderWidth: 0.5,
    borderColor: PALETTE.primaryStrokeLine,
    paddingLeft: 10,
    paddingTop: 10,
    paddingBottom: 10
  }
},
{
  [MQ_TABLET]: {
    tabletBlockCompnentList:{
      flex: 1,
      flexDirection: 'row',
      flexWrap:'wrap',
      alignItems:'flex-start',
    },
    assetTabletView:{
      flex: 1,
      flexDirection: 'row',
      marginTop:20
    },
    assetBlockView:{
      flex: 0.4,
      marginRight: 30
    },
    assetBlockComponent:{
      flexDirection:'row',
    },
    assetListView:{
      flex: 0.6,
    },
    tabletOuterView:{
      alignItems:'center',
      marginTop:20,
    },
    dateSelectionBar:{
      alignSelf:'center',
    },
    header:{
      marginTop:10
    },
  },
});
